module.exports = "../study/imgs/maps/Nagano/S8/Hazard/Slopefailure/Nagano_Slopefailure_MRI_RCP85_End.png";